export default __webpack_public_path__ + "static/Barlow-Bold-0cb1ab864072bf9e0991b19e21463f63.ttf";